import {Injectable} from '@angular/core';
import {environment} from 'src/environments/environment';
import {WindowRefService} from './window-ref.service';

@Injectable()
export class AnalyticService {
  constructor(private windowRef: WindowRefService) {
  }

  public trackEvent(eventName: string, params = {}): void {
    if (environment.production) {
      this.windowRef.nativeWindow.brxTracking.setYaEvent(eventName, params);
    }
  }

  public trackRoistatEvent(eventName: string) {
    if (environment.production) {
      this.windowRef.nativeWindow.brxTracking.sendAnalyticsEvent(eventName);
    }
  }

  public trackAnalyticEvent(eventName, params:any = {}) {
    if (environment.production) {
      this.windowRef.nativeWindow.brxTracking.sendAnalyticsEvent(eventName, params);
    }
  }

  public trackHotelEvent(params = {}) {
    const event = new CustomEvent('send-hotel-event', {
      detail: params,
    });

    this.windowRef.nativeWindow.dispatchEvent(event);
  }
}
